import React, { useEffect, useState } from 'react'
import { blueColour, goldColour, LeftTextRightPicture, lighterBlueColour, Quote, RightTextLeftPicture, Tag } from '../pages/Home'
import T from './Translation'
import { dT } from './Translation'
import TrueFalseToggle, { SidesToggle } from '../whitaijiFrontendLibrary/components/TrueFalseToggle'
import { _FETCH } from '../utils/patches'
import RichTextEditor from '../whitaijiFrontendLibrary/textEditors/RichTextEditor'
import { generateMongoDBId, keyId } from '../whitaijiFrontendLibrary/lib/utils';
import BlueButton from './BlueButton'
import { useStateContext } from '../context/StateContext'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from '../context/AuthContext'
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query'
import { _CREATE, _UPDATE } from '../utils/patches'
import VisDiv from './VisDiv'
import { runFireworks } from './Fireworks'
import TextField from '../whitaijiFrontendLibrary/components/TextField'
import Loading from '../whitaijiFrontendLibrary/components/Loading'
import { useNavigate } from 'react-router-dom'
import format from 'date-fns/format'
import { IoNavigateCircleOutline } from "react-icons/io5";
import EmojiRating from './EmojiRating'
import FieldDropdown from '../whitaijiFrontendLibrary/components/FieldDropdown';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { MdDelete } from "react-icons/md";
import Divider from '../whitaijiFrontendLibrary/components/Divider'
import { errorAlert, sortByOrder, successAlert } from '../utils/utils'
import { IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/io';
import ScrollDiv from './ScrollDiv'
import ProfilePicture from './imageCrop/ProfilePicture'
import { FiEdit } from "react-icons/fi";



const Journal = ({concertLogId, concertTitle, songs=[], submitOnSave,  onSubmit = () => {}, justNewEntry, hideSongDropdown, hideRating}) => {

    const {user} = useAuthContext(AuthContext)
    const {language, apiUrl, hideTestButtons,
       journalEntry, setJournalEntry
    } = useStateContext() 

    const { data: journalsData, isLoading: isLoadingJournalsData } = useQuery({
        queryKey: ['journalEntries'],
        queryFn: async () => {
        try {
            const response = await _FETCH({
            route: `${apiUrl}/journal-entries`,
            user,
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("songs loaded", data)
            return response;
        } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching songs:', error);
            return [];
        }
        },
        enabled: !!user && !justNewEntry,  // Only fetch if user is logged in
        refetchOnWindowFocus: false,
    });

        const { data: songsData, isLoading: isLoadingSongsData } = useQuery({
        queryKey: ['songsDataConcert'],
        queryFn: async () => {
        try {
            const response = await _FETCH({
            route: `${apiUrl}/songs`,
            user,
            });
            //const data = await response.json();
            //process.env.NODE_ENV === "development" && console.log("songs loaded", data)
            return response;
        } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error fetching songs:', error);
            return [];
        }
        },
        enabled: !!user && songs?.length < 1,  // Only fetch if user is logged in
        refetchOnWindowFocus: false,
    });

    const songList = Array.isArray(songs) && songs?.length > 0 ? songs : songsData

    const [journalEntryId, setJournalEntryId] = useState(null)
    const [title, setTitle] = useState(concertTitle)
    const [journalEntryEditorDoc, setJournalEntryEditorDoc] = useState(null)
    const [journalEntryEditorValue, setJournalEntryEditorValue] = useState(null)
    const [customSections, setCustomSections] = useState([])
    const [tags, setTags] = useState([])
    const [rating, setRating] = useState(null)
    const [songId, setSongId] = useState(null)
    const [songTitle, setSongTitle] = useState(null)
    const [shareWithMindPro, setShareWithMindPro] = useState(false)
   
    
    const [error, setError] = useState(null)
    const [submitted, setSubmitted] = useState(false)
    const queryClient = useQueryClient();
    const [showAddNewEntry, setShowAddNewEntry] = useState(justNewEntry || !!journalEntry)
   

    const journalTags = [
        dT({en:"Dream", it: "Sogno"}, language),
        dT({en:"Health", it: "Salute"}, language),
        dT({en:"Life Plans", it: "Piani Di Vita"}, language),
        dT({en:"Relationships", it: "Relazioni"}, language),
        dT({en:"Wealth", it: "Ricchezza"}, language),
        dT({en:"Wish List", it: "Lista Dei Desideri"}, language),
        dT({en:"Other", it: "Altro"}, language),
    ]


    const doc = {
        _id: journalEntryId,
        title,
        concertLogId,
        concertTitle,
        journalEntryEditorDoc,
        rating,
        songId,
        songTitle,
        customSections,
        tags,
        shareWithMindPro

    }
    useEffect(()=>{
        if(journalEntry?._id)
            setJournalEntryId(journalEntry?._id)
            setTitle(journalEntry?.title)
            setJournalEntryEditorDoc(journalEntry?.journalEntryEditorDoc)
            setJournalEntryEditorValue(journalEntry?.journalEntryEditorDoc)
            setRating(journalEntry?.rating)
            setSongId(journalEntry?.songId)
            setSongTitle(journalEntry?.songTitle)
            setCustomSections(journalEntry?.customSections || [])
            setTags(journalEntry?.tags || [])
            setShowAddNewEntry(true)
            setShareWithMindPro(journalEntry?.shareWithMindPro)
        },[journalEntry?._id])

    useEffect(()=>{
        if(journalEntry?._id === doc?._id){
            //console.log("DOC CHANGES klsdklqdjlkw", {doc, journalEntry})
            setJournalEntry(doc)
        }
    },[title, tags, journalEntryEditorDoc, rating, songId, songTitle, customSections, tags, shareWithMindPro, concertLogId, concertTitle])
    
    const addNewJournalEntry = () => {
        const newJournalEntryId = generateMongoDBId()
        setJournalEntry({...doc, _id: newJournalEntryId})
        setJournalEntryId(newJournalEntryId) 
        setShowAddNewEntry(true)   
    }
    const closeJournalEntry = () => {
        setJournalEntry(undefined)
        setShowAddNewEntry(false)   
    }

    useEffect(() => {
        if(submitted) {
            runFireworks()
        }
    }, [submitted])

    const reset = () => {
        closeJournalEntry()
        setTitle(null)
        setJournalEntryEditorDoc(null)
        setError(null)
        setSubmitted(false)
    }
    const updateRating = (newRating) => {
        setRating(newRating)
    }
  const onError = (error) => {
    process.env.NODE_ENV === "development" && console.error('Error journal entry:', error);
    errorAlert(dT({en:"The journal was not saved, please try again", it:"Il capitolo non è stato salvato, riprova"}, language))
  };
  
  const onSuccess = (data) => {
    process.env.NODE_ENV === "development" && console.log('Entry logged successfully:', data);
  };

const { mutate: submitJournalEntry } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('Calling  Submit Journal Entry:', doc);
      return await _CREATE({
        route: `${apiUrl}/journal-entries`, 
        doc: doc, 
        user, 
        onSuccess: (data) => {
            //setJournalEntryId(data?._id)
             process.env.NODE_ENV === "development" && console.log('onSubmit', data)
             successAlert(dT({en:"The journal was created successfully!", it:"Il capitolo è stato aggiunto con successo!"}, language))
   
            if(submitOnSave){
                setSubmitted(true)
                onSubmit(data)
            }
            process.env.NODE_ENV === "development" && console.log('Entry logged successfully:', data)
        }, 
        onError
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['journalEntries'] }),
    mutationKey: ['journalEntries'],
  });
  const { mutate: editJournalEntry } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('Calling UPDATE with doc:', doc);
      return await _UPDATE({
        route: `${apiUrl}/journal-entries/${doc._id}`, 
        doc: doc, 
        user, 
        onSuccess: (data) => {
            //setSubmitted(true)
            process.env.NODE_ENV === "development" && console.log('Entry logged successfully:', data)
            successAlert(dT({en:"The journal was edited successfully!", it:"Il capitolo è stato modificato con successo!"}, language))
        }, 
        onError
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['journalEntries'] }),
    mutationKey: ['journalEntries'],
  });
    const editorDoc = (data) => {
    const newValue = { ...data, blocks: data?.blocks?.map((x) => ({ ...x, _key: keyId() })) };
    setJournalEntryEditorDoc(newValue);
    };
    const update = (value) => {
            const entryExists = !Array.isArray(journalsData) ? undefined : journalsData?.some((x)=>x?._id == value?._id)
            process.env.NODE_ENV === "development" && console.error("Beginning to save:", {entryExists, value});
            //setLaws([...filteredArray, value])
            if(!title) {
                    setError(dT({en:"Please fill the title", it:"per favore scrivi il titolo"}, language))
                    errorAlert(dT({en:"Please fill in the title", it:"per favore scrivi il titolo"}, language))
                    return
            }
/*             if(!journalEntryEditorDoc) {
                    setError(dT({en:"Please fill the journal", it:"per favore scrivi il journal"}, language))
                    return 
                }
            if(journalEntryEditorDoc?.blocks?.length === 1 && !journalEntryEditorDoc.blocks[0].text) {
                    setError(dT({en:"Please fill the journal", it:"per favore scrivi il journal"}, language))
                    return 
            }
                if(journalEntryEditorDoc?.blocks?.every((x) => !x.text)) {
                    setError(dT({en:"Please fill the journal", it:"per favore scrivi il journal"}, language))
                    return 
            } */
            setError(null)
            hideTestButtons && console.log('value updated:', value)

            setJournalEntry(value)
            if(entryExists){
                return  editJournalEntry(value)
            }
            return submitJournalEntry(value)
    }      

    const testFunction = () => {
        console.log("jsnckjnd", {journalsData, doc, songList, journalEntry})
    }

    const songsOptions = !Array.isArray(songList) ? [] : songList
        ?.filter((x)=>{
            if (Array.isArray(songs) && songs.length > 0) {
                return  !x?.isDeepener
            }
            return !x?.isWithPrelude && !x?.isDeepener})
        ?.map((x)=>({label: x?.title, value: x?._id}))

    // ======================= CUSTOM SECTIONS ================

        const addNewEmptyCustomDoc = () => {
            const doc = {
                _id: generateMongoDBId(),
                order: customSections?.length,
                title: "",
                sectionType: undefined,
                roundPicture: true,
            }
             setCustomSections([...customSections, doc ])
         }

    //================================== RETURNS ==================================


    if(isLoadingJournalsData || isLoadingSongsData) {
        return <Loading/>
    }

  return (
    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
        <BlueButton fn={testFunction} hide={hideTestButtons} />
        <VisDiv rules={[!submitted, showAddNewEntry, journalEntry]} style={{ textAlign:"left", backgroundColor:goldColour, width:"96%", margin:"10px", padding:"30px", borderRadius:"10px", }}>
{/*             <TrueFalseToggle
                label = {<T obj={{en:"Report a software bug", it:"reporta un bug del software"}}/>}
                onClick={() => setBug(!bug)}
                value={bug}
            /> */}
            <VisDiv>
                <TrueFalseToggle
                    label= {dT({en: "Share With Your Therapist", it: "Condovidi con il tuo terapista"}, language)}
                    description = {dT({en: "Your therapist will have acccess to this entry, so that you can easily discuss it during the next session ", it: "Il tuo terapista avrà accesso a questo capitolo di modo da potern discuterne durante la prossima sessione"}, language)}
                    value={shareWithMindPro}
                    onClick={()=>{setShareWithMindPro(!shareWithMindPro)}}
                />
            </VisDiv>
            <VisDiv rules={[!hideRating]} style={{marginBottom:"10px"}}>
                <div style={{marginBottom:"10px", textAlign: "center"}}>
                    <h4 style={{fontFamily:"Caveat, cursive", fontSize:"30px"}}>{dT({en: "How do you feel?", it: "Come tis senti?"}, language)}</h4>
                </div>
                <EmojiRating initialRating={rating} ratingCallback={updateRating} />
            </VisDiv>
            <TextField 
                handwrittenLabel={true}
                label={dT({en: "Title", it: "Titolo"}, language)}
                inputStyle={{backgroundColor:"white"}}
                placeHolder={dT({en: "Write the title here", it: "Scrivi il titolo qui"}, language)}
                onChange={(e) => setTitle(e.target.value)}
                value={title}
                //onBlur={() => setConcert({...concert, title})}
            />
            <VisDiv rules={[!hideSongDropdown]} style={{marginBottom:"10px"}}>
                 <h4 style={{fontFamily:"Caveat, cursive", fontSize:"20px"}}>{dT({en: "Is there a song in connection with your journal entry?", it: "C'è una canzone in connessione con il tuo capitolo?"}, language)}</h4>
                <p>{dT({en: "The song will be available in your journal entry", it: "La canzone sarà disponibile nel tuo capitolo"}, language)}</p>
                <FieldDropdown
                    options={songsOptions}
                    selectorStyle={{backgroundColor:"white"}}
                    //initialValue={{label: songTitle, value: songId}}
                    placeHolder= {dT({
                        en: "Select a song or leave empty",
                        it: "Seleziona una canzone o lascia vuoto"}, language
                    )}
                    onChange={(value) =>  {
                        setSongId(value.value)
                        setSongTitle(value.label)
                    }}
                />
            </VisDiv>
            <VisDiv rules={[]} style={{marginBottom:"10px"}}>
                 <h4 style={{fontFamily:"Caveat, cursive", fontSize:"20px"}}>{dT({en: "What are you writing about?", it: "Che tema stai trattando?"}, language)}</h4>
                <ScrollDiv>
                    {journalTags?.map((tag)=>{
                        const isTagInTags = tags?.some((x)=>x == tag)
                        const tagColour = isTagInTags ? lighterBlueColour : "grey"
                        const clickTag = () =>{
                            if(isTagInTags) {
                                setTags(tags?.filter(x=>x !== tag))
                            } else {
                                setTags([...tags, tag])
                            }
                        }
                        return <Tag onClick={clickTag} style={{cursor:"pointer", width: "auto"}} text={tag} color={tagColour}/>
                    })}
                </ScrollDiv>
            </VisDiv>
             <h4 style={{fontFamily:"Caveat, cursive", fontSize:"20px"}}>{dT({en: "Begin writing... now", it: "Inizia a scrivere... ora"}, language)}</h4>
            <div style={{padding:"10px", marginTop:"20px", backgroundColor:"white", borderRadius:"10px"}}>
                <RichTextEditor 
                    placeHolder={dT({en: "Write here", it: "Scrivi qui"}, language)}
                    onChange={(e) => setJournalEntryEditorValue(e.target.value)}
                    noFocus={true}
                    editorDoc={editorDoc}
                    updateInitialData={true}
                    fullWidth={true}
                    //onBlur={()=>update(doc)} 
                    existingDoc={journalEntryEditorValue} 
                />
            </div>
             {error && <div style={{color: 'red', margin:"10px 0px 10px 0px"}}>{error}</div>}
            <Divider color={"white"}/>
            {customSections?.map((customSection, index)=>{
                return(
                    <CustomSection 
                        key={customSection?._id} 
                        setCustomSections={setCustomSections} 
                        customSections={customSections} 
                        customSection={customSection}
                        index={index}
                    />
                )})}
            <VisDiv rules={[]} style={{display:"flex", alignItems:"center", marginLeft:`15px`, padding:"12px"}}>
                <BsFillPlusCircleFill style={{marginRight: "10px"}} size={25} onClick={addNewEmptyCustomDoc} color={blueColour}/>
                <T obj={{en:"Add Section", it: "Aggiungi Sezione"}}/>
            </VisDiv>
            <p style={{marginLeft:`25px`}}><T obj={{en: "You can add a quote, a text and title or a text and picture section", it:"Puo aggiungere una sezione si testo, un detto o testo ed immagine"}}/></p>
             
            <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginTop:"20px"}}>
                <BlueButton hoverColor={blueColour} color="green" text={""} fn={() => update(doc)}>{submitOnSave ? <T obj={{en:"Submit", it:"Invia"}}/>: <T obj={{en:"Save", it:"Salva"}}/>}</BlueButton>
                <BlueButton fn={closeJournalEntry} color={lighterBlueColour} hoverColor={blueColour} text={dT({en:"Close", it:"Chiudi"}, language)}/>

            </div>
        </VisDiv>
        <VisDiv style={{width: "100%"}} rules={[!submitted, !justNewEntry, !journalEntry]}>
{/*             <h2>
                <T obj={{en:"My Journals", it:"I miei diari"}}/>
            </h2> */}
            <div style={{display:"flex", justifyContent:"space-around", alignItems:"center", textAlign: "center", marginBottom:"20px"}}>
                <div style={{flex:1, display:"flex", justifyContent:"left", alignItems:"center"}}>
                    <BlueButton fn={addNewJournalEntry} color={goldColour} hoverColor={blueColour} text={dT({en:"Add New Journal Entry", it:"Aggiungi Nuovo Capitolo"}, language)}/>
                </div>
                <div style={{flex:1, fontSize:"35px"}}>
                    <h2 style={{fontFamily: "'Caveat', cursive"}}> 
                        <T obj={{en:"My Journal", it:"Il Mio Diario"}}/>
                    </h2>
                </div>

                <div style={{flex:1}}></div>
            </div>
            {!Array.isArray(journalsData) ? [] : journalsData?.map((journal, index) => (
                <JournalCard setJournalEntry={setJournalEntry} key={index} journal={journal} />
            ))}
        </VisDiv>
        <VisDiv style={{ textAlign:"center", backgroundColor:goldColour, width:"80%", margin:"10px", padding:"30px", borderRadius:"10px", }} rules={[submitted]}>
            <h2>
                <T obj={{en:"Your journal has been updated!", it:"Il tuo diario è stato aggiornato!"}}/>
            </h2>
             <BlueButton text={<T obj={{en:"Back To Journal", it:"Torna al Diario"}}/>} fn={reset} color='green' />
        </VisDiv>
    </div>
  )
}

export default Journal

export const JournalCard = ({journal={}, setJournalEntry}) => {
    const {title, createdAt, _id, journalEntryEditorDoc, rating, songTitle, concertTitle} = journal;
    const navigate = useNavigate();
    const date  = format(new Date(createdAt), "dd/MM/yyyy HH:mm");
    const journalPlainText = journalEntryEditorDoc?.blocks?.map((x) => x?.text)?.join('');
    function getPreview(text, maxLength = 250) {
        if (!text) return '';
        return text?.length > maxLength
            ? text?.slice(0, maxLength)?.trim() + '...'
            : text;
        }
    
    const openJournal = () => {
        navigate(`/my-journal/journalEntry?_id=${_id}`)

    }

    return (
        <div style={{border:"1px solid #ccc", margin:"10px", padding:"10px", backgroundColor:"white", borderRadius:"10px", display: "flex", alignItems: "center", justifyContent: "flex-start"  }}>
            <div>
                <IoNavigateCircleOutline 
                    style={{marginLeft: "10px", cursor: 'pointer', marginRight: '10px'}} 
                    size={27} 
                    onClick={openJournal}
                />
            </div>
            <VisDiv rules={[true]}>
                <FiEdit 
                  style={{cursor: 'pointer', marginRight: '10px'}} 
                  size={20} 
                  onClick={() => setJournalEntry(journal)}
                />
            </VisDiv>
            <div style={{textAlign:"left", marginLeft:"10px", width:"100%"}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                    <div>
                        {createdAt ? <p>{date}</p> : <p>No date</p>}
                    </div>
                    <div>
                        <EmojiRating emojisSize={25} readOnly={true} initialRating={rating} />
                    </div>
                </div>
                
                <h3 style={{cursor: 'pointer', fontFamily: "'Caveat', cursive", fontSize:"35px"}} onClick={openJournal}>{title}</h3>
                <div style={{display:"flex", flexDirection:"column", gap:"10px", margin:"15px 0px 15px 0px"}}>
                    <VisDiv rules={[songTitle]}>
                        <Tag text={songTitle}/>
                    </VisDiv>
                    <VisDiv rules={[concertTitle]}>
                        <Tag style={{ textAlign: "left"}} color={lighterBlueColour} text={concertTitle} />
                    </VisDiv>
                </div>
                <div style={{ marginTop:"8px"}}>
                    <p>{getPreview(journalPlainText)}</p>
                </div>
                
            </div>
        </div>      
    )
}

export const CustomSection = ({edit = true, customSections, customSection, setCustomSections=()=>{}, index}) => {
    const {language, apiUrl, hideTestButtons} = useStateContext() 
    const {user} = useAuthContext(AuthContext)
    const [title, setTitle] = useState()
    const [order, setOrder] = useState()
    const [sectionType, setSectionType] = useState()
    const [richTextObj, setRichTextObj] = useState()
    const [richTextValue, setRichTextValue] = useState()
    const [quoteText, setQuoteText] = useState()
    const [quoteAuthor, setQuoteAuthor] = useState()
    const [imageSource, setImageSource] = useState ()
    const [roundPicture, setRoundPicture] = useState(true) 
    const [flipImageText, setFlipImageText] = useState()
    const [resetPhoto, setResetPhoto] = useState(false)


    const imageSources = () => {
        if(imageSource) return imageSource
        if(customSection?.imageSource) return customSection?.imageSource
        return "/homePictures/imagePlaceholder.jpg"
    }

    useEffect(()=>{
        setTitle(customSection?.title)
        //console.log("LOADING SECTION TYPE",{inDoc: customSection?.sectionType, sectionType})
        setSectionType(customSection?.sectionType)
        setRichTextObj(customSection?.richTextObj)
        setRichTextValue(customSection?.richTextObj)
        setQuoteText(customSection?.quoteText)
        setQuoteAuthor(customSection?.quoteAuthor)
        setRoundPicture(customSection?.roundPicture || true)
        setImageSource(customSection?.imageSource)
        //setImageSource("/homePictures/mikeAnxiety.png")
        setFlipImageText(customSection?.flipImageText)
    },[])

    useEffect(()=>{
        setOrder(customSection?.order)
    },[customSections])

    

    const sectionTypes = [
        {label: dT({en:"Quote", it:"Detto"}, language), value: "quote"},
        {label: dT({en:"Title And Text", it:"Titolo E Testo"}, language), value: "titleText"},
        {label: dT({en:"Image And Text", it:"Testo e immagine"}, language), value: "imageText"},
    ]
       const doc = {
                _id: customSection?._id,
                order,
                title,
                sectionType,
                richTextObj,
                quoteText,
                quoteAuthor,
                imageSource,
                roundPicture,
                flipImageText
            }
    const deleteCustomSection = () =>{
        setCustomSections([...customSections?.filter((x)=>x?._id !== customSection?._id)])
    }
    const updateCustomSection = () => {
        setCustomSections([...customSections?.filter((x)=>x?._id !== customSection?._id), doc]?.sort(sortByOrder))
    }
    const moveUp = () => {
        const newOrder = order - 1.5
        const newArray = [...customSections?.filter((x)=>x?._id !== customSection?._id), {...doc, order: newOrder}]?.sort(sortByOrder)
        const shiftedOrders = newArray?.map((x, i)=>{return({...x, order: i})})        
        const findNewDoc = shiftedOrders?.find((x) => x?._id == customSection?._id)
        setOrder(findNewDoc?.order)
        setCustomSections(shiftedOrders?.sort(sortByOrder))
        //console.log("MOVE DOWN",{order, index, newOrder, shiftedOrders, findNewDoc, newArray})
    }
        
    const moveDown = () => {
        const newOrder = order + 1.5
        const newArray = [...customSections?.filter((x)=>x?._id !== customSection?._id), {...doc, order: newOrder}]?.sort(sortByOrder)
        const shiftedOrders = newArray?.map((x, i)=>{return({...x, order: i})})
        const findNewDoc = shiftedOrders?.find((x) => x?._id == customSection?._id)
        setOrder(findNewDoc?.order)
        setCustomSections(shiftedOrders?.sort(sortByOrder))
        //console.log("MOVE DOWN",{order, index, newOrder, shiftedOrders, findNewDoc, newArray})

    }
    const uploadPictureToS3 = async(data) => {
        try {
          process.env.NODE_ENV === "development" && console.log("uploadPictureToS3:", {
            hasPhotoFile: !!data?.photoFile,
            photoFileType: typeof data?.photoFile,
            hasFile: !!data?.photoFile?.file,
            fileType: typeof data?.photoFile?.file
          });
          
          const file = data?.photoFile?.file;
          const fileName = customSection?._id

         const image = new File([file], fileName, {
                type: file.type,
                });

        
          console.log ("IMAGE AND NEW FILE NAME", image, fileName)

          if(!image){
            //throw new Error('No Photo file');
            errorAlert(dT({en:"No Photo file", it:"Manca il file della foto"}, language))
            process.env.NODE_ENV === "development" && console.error('No Photo file');

            setResetPhoto(true)
            return
          }
        if(!fileName){
            //throw new Error('No Photo file name');
            
            errorAlert(dT({en:"No file name found", it:"Manca il nome del file"}, language))
            
            process.env.NODE_ENV === "development" && console.error("no photo file name");
            setResetPhoto(true)
            setResetPhoto(true)
            return
        }
        if(image?.originalName !== fileName){
            //throw new Error('No Photo file name');
            
            errorAlert(dT({en:"No id file name found", it:"Manca il nome id del file"}, language))
            
            process.env.NODE_ENV === "development" && console.error("no photo file id name");
            setResetPhoto(true)
            return
        }
          // Create form data for S3 upload
          const formData = new FormData();
          formData.append('file', image);
        
          
          
          // The user ID is extracted from the JWT token on the server side
          // through the requireAuth middleware, so we don't need to pass it explicitly
          process.env.NODE_ENV === "development" && console.log("Uploading profile picture to S3", {formData});

          // Upload to S3
          const s3Response = await fetch(`${apiUrl}/s3/upload-picture`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${user.token}`
            },
            body: formData
          });

          // Parse the response data
          const responseData = await s3Response.json();
          
          if (!s3Response.ok) {
            //throw new Error(responseData.error || 'Failed to upload image to S3');
            errorAlert(dT({en:"It was not possible to upload the photo, try again", it:"Non è stato possibile caricare la foto, riprova"}, language))
            process.env.NODE_ENV === "development" && console.error('Failed to upload image, response not ok');
            setResetPhoto(true)
            return
          }
          
          // Update the user info with the new profile picture URL

          setImageSource(responseData?.imageSource)
         
        //`https://${process.env.S3_BUCKET_PUBLIC}.s3.${process.env.AWS_REGION}.amazonaws.com/users/${userId}/journal-images/${fileName}`;

          process.env.NODE_ENV === "development" && console.log('Successfully uploaded profile image:', responseData.imageSource);
    
          return ({
            success: true, 
            imageSource: responseData.imageSource,
            shortUrl: responseData.shortUrl


        });
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error uploading profile picture:', error);
          setResetPhoto(true)
          return ({success: false});
        }
      }
    const processImage = async(data) => {
        const image = data?.photoFile?.file
          let imageSource
          let shortUrl 
          
          // Upload profile picture to S3
          if(image){
            const uploadPictureResponse = await uploadPictureToS3(data)
            if(!uploadPictureResponse?.success){
              //throw new Error('Failed to upload profile picture')
              errorAlert(dT({en:"It was not possible to upload the photo, try again", it:"Non è stato possibile caricare la foto, riprova"}, language))
              process.env.NODE_ENV === "development" && console.error('Failed to upload profile picture in process image');
              return
            }
            const returnedShortUrl = uploadPictureResponse.imageSource
            const returnedImageSource = uploadPictureResponse.imageSource
            // The profile picture URL is already updated in the state by uploadPictureToS3
            process.env.NODE_ENV === "development" && console.log('Successfully saved profile picture:', uploadPictureResponse.imageSource);
            imageSource = returnedImageSource
            shortUrl = returnedShortUrl
            console.log("processed image success djfhskdhfskdjfh", {data, image, imageSource, shortUrl})
          }
        
    }
    const editorDoc = (data) => {
        const newValue = { ...data, blocks: data?.blocks?.map((x) => ({ ...x, _key: keyId() })) };
        setRichTextObj(newValue);
        };
    return (
        <div style={{padding: "15px"}}>
        <VisDiv rules={[edit]}>   
            <div style={{display:"flex", justifyContent:"space-between"}}>
                <div style={{display:"flex", justifyContent:"flex-end"}} className="delete-trash-can" onClick={deleteCustomSection}>
                    <MdDelete size={20} color="red" />
                    <h3>{title ? title : <T obj={{en:"CustomSection", it:"Sezione Personalizzata"}}/>}</h3>
                </div>
                <div style={{display:"flex", flexDirection:"column", alignItems:"flex-end"}}>
                    <VisDiv rules={[order !== 0]} onClick={moveUp} style={{display:"flex", marginBottom:"6px", alignItems:"center", cursor:"pointer"}} >
                        <p style={{cursor:"pointer"}} onClick={moveUp} ><T obj={{en: "Move Up", it:"Sposta Su"}}/></p>
                        <IoIosArrowDropup size={25}/>
                    </VisDiv>
                    <VisDiv rules={[order !== customSections?.length -1]}  onClick={moveDown} style={{display:"flex", alignItems:"center",  cursor:"pointer", marginLeft:"10px"}} >
                        <p><T obj={{en: "Move Down", it:"Sposta Giù"}}/></p>
                        <IoIosArrowDropdown size={25}/>
                    </VisDiv>
                </div>

            </div> 
                <FieldDropdown
                    options={sectionTypes}
                    selectorStyle={{backgroundColor:"white"}}
                    initialValue={sectionType || customSection?.sectionType}
                    placeHolder= {dT({
                        en: "Select a section type",
                        it: "Seleziona una tipologia di sezione"}, language
                    )}
                    onChange={(value) =>  {
                        setSectionType(value)
                        setCustomSections([...customSections?.filter((x)=>x?._id !== customSection?._id), {...doc, sectionType: value}]?.sort(sortByOrder))

                    }}
                />
            </VisDiv>
            <div>
                <VisDiv rules={[sectionType?.value == "quote"]}>
                    <VisDiv rules={[edit]}>
                        <TextField 
                            label={dT({en: "Quote", it: "Detto"}, language)}
                            handwrittenLabel={true}
                            placeHolder={dT({en: "Write the quote here", it: "Scrivi il detto qui"}, language)}
                            inputStyle={{backgroundColor:"white"}}
                            onChange={(e) => setQuoteText(e.target.value)}
                            value={quoteText}
                            textArea={true}
                            onBlur={updateCustomSection}
                        />  
                        <TextField 
                            label={dT({en: "Author", it: "Autore"}, language)}
                            handwrittenLabel={true}
                            placeHolder={dT({en: "Write the quote author here", it: "Scrivi l'autore del detto qui"}, language)}
                            inputStyle={{backgroundColor:"white"}}
                            onChange={(e) => setQuoteAuthor(e.target.value)}
                            value={quoteAuthor}
                            onBlur={updateCustomSection}
                        />                        

                    </VisDiv>
                    <VisDiv>
                        <div className={"blue-background"} style={{padding: "30px", marginBottom: "20px"}}>
                        <Quote dark author={quoteAuthor}>
                            {quoteText}
                        </Quote>
                        </div>
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[sectionType?.value == "titleText"]}>
                    <VisDiv rules={[edit]}>
                        <TextField 
                            label={dT({en: "Section Title", it: "Titolo Sezione"}, language)}
                            handwrittenLabel={true}
                            placeHolder={dT({en: "Write the title here", it: "Scrivi il titolo qui"}, language)}
                            inputStyle={{backgroundColor:"white"}}
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                            onBlur={updateCustomSection}
                        />  
                        <div style={{padding:"10px", marginTop:"20px", backgroundColor:"white", borderRadius:"10px"}}>
                            <RichTextEditor 
                                onChange={(e) => setRichTextValue(e.target.value)}
                                noFocus={true}
                                editorDoc={editorDoc}
                                updateInitialData={true}
                                fullWidth={true}
                                onBlur={updateCustomSection}
                                existingDoc={richTextValue} 
                            />
                        </div>
                    </VisDiv>
                </VisDiv>
                <VisDiv rules={[sectionType?.value == "imageText"]}>
                    <VisDiv rules={[edit]}>
                        <TextField 
                            label={dT({en: "Section Title", it: "Titolo Sezione"}, language)}
                            handwrittenLabel={true}
                            placeHolder={dT({en: "Write the title here", it: "Scrivi il titolo qui"}, language)}
                            inputStyle={{backgroundColor:"white"}}
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                            onBlur={updateCustomSection}
                        />  
                        <TextField 
                            label={dT({en: "Image link", it: "link Immagine"}, language)}
                            handwrittenLabel={true}
                            placeHolder={dT({en: "insert a web url to the picture here", it: "Inserisci il link ad un immagine qui"}, language)}
                            inputStyle={{backgroundColor:"white"}}
                            onChange={(e) => setImageSource(e.target.value)}
                            value={imageSource}
                            onBlur={updateCustomSection}
                        />  
                        <ProfilePicture setReset={setResetPhoto} reset={resetPhoto} profile={roundPicture} doc={{imageSource: imageSources()}} setDoc={processImage} />
                        <TrueFalseToggle
                            value={roundPicture}
                            onClick={()=>{
                                setRoundPicture(!roundPicture);
                                setCustomSections([...customSections?.filter((x)=>x?._id !== customSection?._id), {...doc, roundPicture: !roundPicture}]?.sort(sortByOrder))

                            }}
                            label={dT({en:"Round Picture", it:"Foto Rotonda"}, language)}
                            description={dT({en:"makes your picture round", it:"rende la tua immagine rotonda"}, language)}

                        />
                        <SidesToggle
                            value={flipImageText}
                            onClick={()=>{
                                setFlipImageText(!flipImageText);
                                setCustomSections([...customSections?.filter((x)=>x?._id !== customSection?._id), {...doc, flipImageText: !flipImageText}]?.sort(sortByOrder))

                            }}
                            label={dT({en:"Change Image Side", it:"Cambia Lato Immagine"}, language)}
                            description={dT({en:"In mobile view the photo is always under the text", it:"Per la versione mobile la foto è sempre sotto il testo"}, language)}
                        />
                        <div style={{padding:"10px", marginTop:"20px", backgroundColor:"white", borderRadius:"10px"}}>
                            <RichTextEditor 
                                onChange={(e) => setRichTextValue(e.target.value)}
                                placeHolder={dT({en: "Write here", it: "Scrivi qui"}, language)}
                                noFocus={true}
                                editorDoc={editorDoc}
                                updateInitialData={true}
                                fullWidth={true}
                                onBlur={updateCustomSection}
                                existingDoc={richTextValue} 
                            />
                        </div>
                    </VisDiv>
                    <VisDiv rules={[!flipImageText]}>
                        <LeftTextRightPicture 
                            withModal={true} 
                            imageStyle={{width:"80%", borderRadius: roundPicture ? "100%": "0px"}}  
                            imageContainerStyle={{width:"100%",justifyContent:"center", alignItems:"center"}} 
                            screenChange={1310} 
                            imageSource={imageSources()}
                            title={title}
                            >
                            <div style={{}}>
                                <RichTextEditor 
                                    //onChange={(e) => setRichTextValue(e.target.value)}
                                    
                                    readOnly={true}
                                    noFocus={true}
                                    //editorDoc={editorDoc}
                                    updateInitialData={true}
                                    fullWidth={true}
                                    //onBlur={updateCustomSection}
                                    existingDoc={richTextObj} 
                                />
                            </div>
                        </LeftTextRightPicture>  
                    </VisDiv>
                    <VisDiv rules={[flipImageText]}>
                        <RightTextLeftPicture 
                            withModal={true} 
                            imageStyle={{width:"80%", borderRadius: roundPicture ? "100%" : "0px"}}  
                            imageContainerStyle={{alignItems:"center"}} 
                            screenChange={1310} 
                            imageSource={imageSources()}
                            title={title}
                            >
                            <div style={{}}>
                                <RichTextEditor 
                                    //onChange={(e) => setRichTextValue(e.target.value)}
                                    readOnly={true}
                                    noFocus={true}
                                    //editorDoc={editorDoc}
                                    updateInitialData={true}
                                    fullWidth={true}
                                    //onBlur={updateCustomSection}
                                    existingDoc={richTextObj} 
                                />
                            </div>
                        </RightTextLeftPicture> 
                    </VisDiv>
                </VisDiv>

            </div>
           <Divider color={"white"}/>
        </div>
        )
}